export const BASE_ELEMENT_IGNORED_FIELDS = [
    "onShowing",
    "onHidden",
    "popoverId",
    "popoverClassName",
    "popoverWidth",
    "popoverHeight",
    "position",
    "popoverContent",
    "popoverTitle",
    "hideEvent",
    "showEvent",
    "popoverRef",
    "toolbarItems",
    "container",
    "overlaysManager",
    "getOverlaysContainer",
    "hideOnOutsideClick",
    "hideOnParentScroll",
    "ignoreHidingWhenChanged",
    "zIndex",
    "ignoreHidingWhenChanged",
    "defaultVisible",
    "visible"
];
